export default __webpack_public_path__ + "static/media/zendy-log.695c1749.png";